import type { RolePayload } from '@Application/Security/Roles/Actions/rolesFetched';

export type RoleUpdatedPayload = RolePayload;

export type RoleUpdatedAction = {
	type: 'ROLE_UPDATED';
	payload: RoleUpdatedPayload;
	accountId: number;
};

export default (payload: RoleUpdatedPayload, accountId: number): RoleUpdatedAction => ({
	type: 'ROLE_UPDATED',
	payload,
	accountId,
});
